// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_Vend_Purchase_Price"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "AccountNum",
      label: "供应商",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      width: "12rem"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short"
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true
    },
    {
      key: "QuantityAmountFrom",
      label: "实际数量(从)",
      sortable: true,
      type: "number"
    },
    {
      key: "QuantityAmountTo",
      label: "实际数量(至)",
      sortable: true,
      type: "number"
    },
    {
      key: "Amount",
      label: "实际含税价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "CurrencyCode",
      label: "实际采购币种",
      sortable: true,
      editable: false
    },
    { key: 'quotationType', label: '报价类型', sortable: true, thStyle: { width: "120px" } },
    {
      key: "TaxGroup",
      label: "税组",
      sortable: true
    },
    {
      key: "AmountWOTax",
      label: "实际本币净单价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "QuantityAmount",
      label: "初始报价数量(从-至)",
      sortable: false
    },
    {
      key: "Initial_Vend_Price",
      label: "初始含税报价",
      sortable: false,
      type: "just_number"
    },
    {
      key: "InitialCurrencyCode",
      label: "初始报价币种",
      sortable: true,
      editable: false
    },
    {
      key: "Initial_Vend_Price_WOTax",
      label: "初始本币净单价",
      sortable: false,
      type: "just_number"
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      type: "date"
    },
    {
      key: "Remark",
      label: "价格备注",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "Cost_Sum",
      label: "成本合计",
      thStyle: {
        width: "6rem"
      },
      sortable: true,
      _precise: 2
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "VQApprover",
      label: "报价待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "fcCheckDocumentApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentApproved",
      context: ["待审批", "已审批"]
    }
  ],
  default_all: [
    {
      key: "id",
      label: "编号"
    },
    {
      key: "AccountNum",
      label: "供应商"
    },
    {
      key: "SEI_Name",
      label: "供应商名称"
    },
    {
      key: "ItemId",
      label: "物料编号"
    },
    {
      key: "NameAlias",
      label: "物料名称"
    },
    {
      key: "VariantName",
      label: "变型名称"
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户"
    },
    {
      key: "DW_CustName",
      label: "客户名称"
    },
    {
      key: "QuantityAmountFrom",
      label: "实际数量(从)",
      type: "number"
    },
    {
      key: "QuantityAmountTo",
      label: "实际数量(至)",
      type: "number"
    },
    {
      key: "Amount",
      label: "实际含税价",
      type: "just_number"
    },
    {
      key: "CurrencyCode",
      label: "实际采购币种",
      sortable: true,
      editable: true
    },
    { key: 'quotationType', label: '报价类型', sortable: true, thStyle: { width: "120px" } },
    {
      key: "TaxGroup",
      label: "税组",
      editable: true,
      sortable: true
    },
    {
      key: "AmountWOTax",
      label: "实际本币净单价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "QuantityAmount",
      label: "初始报价数量(从-至)"
    },
    {
      key: "Initial_Vend_Price",
      label: "初始含税报价",
      type: "just_number"
    },
    {
      key: "InitialCurrencyCode",
      label: "初始报价币种",
      sortable: true,
      editable: false
    },
    {
      key: "Initial_Vend_Price_WOTax",
      label: "初始本币净单价",
      type: "just_number"
    },
    {
      key: "FromDate",
      label: "开始日期",
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      type: "date"
    },

    {
      key: "Remark",
      label: "价格备注",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      type: "datetime"
    },
    // {
    //   key: "is_deleted",
    //   label: "删除",
    //   type: "boolean"
    // },
    // {
    //   key: "deleted_by",
    //   label: "删除人",
    //   formatter: (value, key, item) => {
    //     return item.deleted_by_username;
    //   }
    // },
    // {
    //   key: "deleted_at",
    //   label: "删除时间",
    //   type: "datetime"
    // },
    {
      key: "is_approved",
      label: "审批",
      type: "boolean"
    },
    {
      key: "EXP",
      label: "EXP",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M11",
      label: "M11纸张",
      type: "number"
    },
    {
      key: "M12",
      label: "M21油墨",
      type: "number"
    },
    {
      key: "M22",
      label: "M22光油",
      type: "number"
    },
    {
      key: "M23",
      label: "M23胶水",
      type: "number"
    },
    {
      key: "M24CTP",
      label: "M24CTP版",
      type: "number"
    },
    {
      key: "M25",
      label: "M25其他辅料",
      type: "number"
    },
    {
      key: "M26",
      label: "M26办公劳保",
      type: "number"
    },
    {
      key: "O11",
      label: "O11直接人工",
      type: "number"
    },
    {
      key: "O12",
      label: "O12间接人工",
      type: "number"
    },
    {
      key: "O23",
      label: "O23电",
      type: "number"
    },
    {
      key: "O24",
      label: "O24折旧",
      type: "number"
    },
    {
      key: "O25",
      label: "O25其他变动费用",
      type: "number"
    },
    {
      key: "O26",
      label: "O26其他固定费用",
      type: "number"
    },
    {
      key: "S11",
      label: "S11委外加工费",
      type: "number"
    },
    {
      key: "X",
      label: "X备件",
      type: "number"
    },
    {
      key: "Y",
      label: "Y半成品",
      type: "number"
    },
    {
      key: "Z",
      label: "Z成品",
      type: "number"
    },
    {
      key: "Cost_detail",
      label: "成本明细号",
      type: "textarea"
    },
    {
      key: "Cost_Sum",
      label: "成本合计",
      thStyle: {
        width: "6rem"
      }
    }
  ],
  invent_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "TEC_NetArea",
      label: "净面积",
      sortable: true,
      type: "number"
    },
    // { key: "TEC_SpecType", label: "规格型号", sortable: true },
    {
      key: "TEC_Weight",
      label: "单位重量",
      sortable: true,
      type: "number"
    },
    {
      key: "DW_InventUnitId",
      label: "单位",
      sortable: true
    }
    // { key: "DW_ItemGroupId", label: "物料组", sortable: true },
    // {
    //   key: "modifiedDateTime",
    //   label: "修改日期和时间",
    // }
  ],
  item_fileds: [
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "RetailVariantId",
      label: "变型名称",
      sortable: true,
      editable: false,
      type: "short",
      width: "12rem"
    },
    {
      key: "AccountNum",
      label: "供应商",
      sortable: true,
      width: "60px"
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      width: "12rem"
    },
    {
      key: "QuantityAmountFrom",
      label: "实际数量(从)",
      sortable: true,
      // editable: true,
      type: "number"
    },
    {
      key: "QuantityAmountTo",
      label: "实际数量(至)",
      sortable: true,
      // editable: true,
      type: "number"
    },
    {
      key: "Amount",
      label: "实际含税价",
      sortable: true,
      editable: true,
      type: "just_number"
    },
    {
      key: "CurrencyCode",
      label: "实际采购币种",
      sortable: true,
      editable: true,
      thStyle: {
        width: "10rem"
      }
    },
    { key: 'quotationType', label: '报价类型', sortable: true, thStyle: { width: "120px" } },
    {
      key: "TaxGroup",
      label: "税组",
      sortable: true,
      editable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "AmountWOTax",
      label: "实际本币净单价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "QuantityAmount",
      label: "初始报价数量(从-至)",
      sortable: false,
      editable: false
    },
    {
      key: "Initial_Vend_Price",
      label: "初始含税报价",
      sortable: false,
      editable: false,
      type: "just_number"
    },
    {
      key: "InitialCurrencyCode",
      label: "初始报价币种",
      sortable: true,
      editable: false
    },
    {
      key: "Initial_Vend_Price_WOTax",
      label: "初始本币净单价",
      type: "just_number"
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      type: "date"
    },

    {
      key: "Remark",
      label: "价格备注",
      sortable: true,
      editable: true,
      type: "textarea"
    },
    {
      key: "Cost_Sum",
      label: "成本合计",
      sortable: true,
      width: "5rem",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "EXP",
      label: "EXP",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M11",
      label: "M11纸张",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M12",
      label: "M21油墨",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M22",
      label: "M22光油",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M23",
      label: "M23胶水",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M24CTP",
      label: "M24CTP版",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M25",
      label: "M25其他辅料",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M26",
      label: "M26办公劳保",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O11",
      label: "O11直接人工",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O12",
      label: "O12间接人工",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O23",
      label: "O23电",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O24",
      label: "O24折旧",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O25",
      label: "O25其他变动费用",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O26",
      label: "O26其他固定费用",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "S11",
      label: "S11委外加工费",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "X",
      label: "X备件",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "Y",
      label: "Y半成品",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "Z",
      label: "Z成品",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "Cost_detail",
      label: "成本明细号",
      sortable: true,
      editable: true,
      type: "textarea"
    }
  ],
  default_internal: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "AccountNum",
      label: "供应商",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      width: "12rem"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short"
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true
    },
    {
      key: "QuantityAmountFrom",
      label: "内部采购数量(从)",
      sortable: true,
      type: "number"
    },
    {
      key: "QuantityAmountTo",
      label: "内部采购数量(至)",
      sortable: true,
      type: "number"
    },
    {
      key: "Amount",
      label: "内部采购含税报价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "CurrencyCode",
      label: "内部采购币种",
      sortable: true
    },
    {
      key: "TaxGroup",
      label: "税组",
      sortable: true
    },

    {
      key: "AmountWOTax",
      label: "内部采购本币净单价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      type: "date"
    },
    {
      key: "Remark",
      label: "价格备注",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "Cost_Sum",
      label: "成本合计",
      thStyle: {
        width: "6rem"
      },
      sortable: true,
      _precise: 2
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "VQApprover",
      label: "报价待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "fcCheckDocumentApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentApproved",
      context: ["待审批", "已审批"]
    }
  ],
  default_all_internal: [
    {
      key: "id",
      label: "编号"
    },
    {
      key: "AccountNum",
      label: "供应商"
    },
    {
      key: "SEI_Name",
      label: "供应商名称"
    },
    {
      key: "ItemId",
      label: "物料编号"
    },
    {
      key: "NameAlias",
      label: "物料名称"
    },
    {
      key: "VariantName",
      label: "变型名称"
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户"
    },
    {
      key: "DW_CustName",
      label: "客户名称"
    },
    {
      key: "QuantityAmountFrom",
      label: "内部采购数量(从)",
      type: "number"
    },
    {
      key: "QuantityAmountTo",
      label: "内部采购数量(至)",
      type: "number"
    },
    {
      key: "Amount",
      label: "内部采购含税报价",
      type: "just_number"
    },
    {
      key: "CurrencyCode",
      label: "内部采购币种"
    },
    {
      key: "TaxGroup",
      label: "税组",
      editable: true,
      sortable: true
    },
    {
      key: "AmountWOTax",
      label: "内部采购本币净单价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "FromDate",
      label: "开始日期",
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      type: "date"
    },

    {
      key: "Remark",
      label: "价格备注",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      type: "datetime"
    },
    // {
    //   key: "is_deleted",
    //   label: "删除",
    //   type: "boolean"
    // },
    // {
    //   key: "deleted_by",
    //   label: "删除人",
    //   formatter: (value, key, item) => {
    //     return item.deleted_by_username;
    //   }
    // },
    // {
    //   key: "deleted_at",
    //   label: "删除时间",
    //   type: "datetime"
    // },
    {
      key: "is_approved",
      label: "审批",
      type: "boolean"
    },
    {
      key: "EXP",
      label: "EXP",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M11",
      label: "M11纸张",
      type: "number"
    },
    {
      key: "M12",
      label: "M21油墨",
      type: "number"
    },
    {
      key: "M22",
      label: "M22光油",
      type: "number"
    },
    {
      key: "M23",
      label: "M23胶水",
      type: "number"
    },
    {
      key: "M24CTP",
      label: "M24CTP版",
      type: "number"
    },
    {
      key: "M25",
      label: "M25其他辅料",
      type: "number"
    },
    {
      key: "M26",
      label: "M26办公劳保",
      type: "number"
    },
    {
      key: "O11",
      label: "O11直接人工",
      type: "number"
    },
    {
      key: "O12",
      label: "O12间接人工",
      type: "number"
    },
    {
      key: "O23",
      label: "O23电",
      type: "number"
    },
    {
      key: "O24",
      label: "O24折旧",
      type: "number"
    },
    {
      key: "O25",
      label: "O25其他变动费用",
      type: "number"
    },
    {
      key: "O26",
      label: "O26其他固定费用",
      type: "number"
    },
    {
      key: "S11",
      label: "S11委外加工费",
      type: "number"
    },
    {
      key: "X",
      label: "X备件",
      type: "number"
    },
    {
      key: "Y",
      label: "Y半成品",
      type: "number"
    },
    {
      key: "Z",
      label: "Z成品",
      type: "number"
    },
    {
      key: "Cost_detail",
      label: "成本明细号",
      type: "textarea"
    },
    {
      key: "Cost_Sum",
      label: "成本合计",
      thStyle: {
        width: "6rem"
      }
    }
  ],
  item_fileds_internal: [
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "RetailVariantId",
      label: "变型名称",
      sortable: true,
      editable: false,
      type: "short",
      width: "12rem"
    },
    {
      key: "AccountNum",
      label: "供应商",
      sortable: true,
      width: "60px"
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      width: "12rem"
    },
    {
      key: "QuantityAmountFrom",
      label: "内部采购数量(从)",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "QuantityAmountTo",
      label: "内部采购数量(至)",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "Amount",
      label: "内部采购含税报价",
      sortable: true,
      editable: true,
      type: "just_number"
    },
    {
      key: "CurrencyCode",
      label: "内部采购币种",
      sortable: true,
      editable: true,
      width: "10rem",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "TaxGroup",
      label: "税组",
      editable: true,
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "AmountWOTax",
      label: "内部采购本币净单价",
      sortable: true,
      type: "just_number"
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      editable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      editable: true,
      type: "date"
    },

    {
      key: "Remark",
      label: "价格备注",
      sortable: true,
      editable: true,
      type: "textarea"
    },
    {
      key: "Cost_Sum",
      label: "成本合计",
      sortable: true,
      width: "5rem",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "EXP",
      label: "EXP",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M11",
      label: "M11纸张",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M12",
      label: "M21油墨",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M22",
      label: "M22光油",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M23",
      label: "M23胶水",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M24CTP",
      label: "M24CTP版",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M25",
      label: "M25其他辅料",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "M26",
      label: "M26办公劳保",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O11",
      label: "O11直接人工",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O12",
      label: "O12间接人工",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O23",
      label: "O23电",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O24",
      label: "O24折旧",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O25",
      label: "O25其他变动费用",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "O26",
      label: "O26其他固定费用",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "S11",
      label: "S11委外加工费",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "X",
      label: "X备件",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "Y",
      label: "Y半成品",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "Z",
      label: "Z成品",
      sortable: true,
      editable: true,
      type: "number"
    },
    {
      key: "Cost_detail",
      label: "成本明细号",
      sortable: true,
      editable: true,
      type: "textarea"
    }
  ]
}

const dataForm = {
  id: "",
  ItemId: "",
  dataAreaId: "",
  AccountNum: "",
  SEI_Name: "", ///供应商名称
  NameAlias: "",
  RetailVariantId: "", //变形名称
  VariantName: "",
  TEC_CustAccount: "",
  DW_CustName: "",
  QuantityAmountFrom: "",
  QuantityAmountTo: "",
  Amount: "",
  AmountWOTax: "",
  TaxGroup: "",
  FromDate: "",
  ToDate: "",
  Remark: "",
  CurrencyCode: "",
  QuantityAmount: "", //初始报价数量从-至
  Initial_Vend_Price: "", //最初报价
  Initial_Vend_Price_WOTax: "", //最初本币净单价
  InitialCurrencyCode: "",//初始报价币种
  quotationType: "大货报价",
  // Sales_Price: "", //销售报价
  // Sales_Cost: "", //报价成本
  EXP: "",
  M11: "",
  M12: "",
  M22: "",
  M23: "",
  M24CTP: "",
  M25: "",
  M26: "",
  O11: "",
  O12: "",
  O23: "",
  O24: "",
  O25: "",
  O26: "",
  S11: "",
  X: "",
  Y: "",
  Z: "",
  Cost_detail: "",
  Cost_Sum: ""
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  //get
  async getData(_params, documentType) {
    // let _fields = _.map(fields.default, "key");
    let _fields_all = _.map(fields.default_all, "key")
    _fields_all.push("RetailVariantId")
    _fields_all.push("fcGetDocumentApprover('" + documentType + "','',t.id)")
    _fields_all.push("fcCheckDocumentApproved('" + documentType + "','',t.id)")
    let _actions = []
    // _actions.push(
    //   biz_data
    //     .selectAction({
    //       params: _params,
    //       fields: _fields
    //     })
    //     .action({})
    // );
    // const vend_rate_biz_data = new biz_data_helper.base_entity_helper(
    //   "sPlant_Rate",
    //   {},
    //   {}
    // );
    // _actions.push(
    //   vend_rate_biz_data
    //     .selectAction({
    //       params: {
    //         is_deleted: {
    //           "=": 0
    //         }
    //       },
    //       fields: ["id", "VendAccountNum", "TotalScore"]
    //     })
    //     .action({})
    // );
    _actions.push(
      biz_data
        .selectAction({
          params: _params,
          fields: _fields_all
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }

    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _fields
    //   })
    //   .run();
    // if (
    //   result &&
    //   result[0].result &&
    //   result[0].result.data &&
    //   result[0].result.data.ActionResult &&
    //   result[0].result.data.ActionResult.Result &&
    //   result[0].result.data.ActionResult.Result.Data.length > 0
    // ) {
    //   return result[0].result.data.ActionResult.Result.Data;
    // } else {
    //   return null;
    // }
  },
  async getSimpleData(_params) {
    let _fields = _.map(fields.default, "key")
    _fields.push("RetailVariantId")
    let _actions = []

    _actions.push(
      biz_data
        .selectAction({
          params: _params,
          fields: _fields
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///save
  async saveData(items, documentType) {
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    let add_list = [],
      update_list = []
    _.each(items, t => {
      if (_.isInteger(t.id)) {
        update_list.push(t)
      } else {
        add_list.push(t)
      }
    })

    let batch_actions = []
    if (add_list.length > 0) {
      _.each(add_list, t => {
        let _new = _.cloneDeep(dataForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        delete _new.id
        batch_actions.push(
          biz_data
            .insertAction({
              params: _new,
              fields: ["id"]
            })
            .action({
              output_last_item_map: {
                id: "id"
              }
            })
        )
        ///外部供应商初始报价审批
        let price_form = {
          itemId: "",
          documentType: documentType,
          approveType: "",
          documentCreateByUsername: t.create_by_username
        }
        batch_actions.push(
          so_approve_biz_data
            .execAction({
              params: price_form,
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                itemId: "id"
              }
            })
        )
        batch_actions.push(
          biz_data
            .updateAction({
              params: { id: "", Remark: _new.Remark },
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                id: "id"
              }
            })
        )
      })
    }

    if (update_list.length > 0) {
      _.each(update_list, t => {
        let _new = _.cloneDeep(dataForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        batch_actions.push(
          biz_data
            .updateAction({
              params: _new,
              fields: ["id"]
            })
            .action({})
        )
        ///外部供应商初始报价审批
        let price_form = {
          itemId: t.id,
          documentType: documentType,
          approveType: "",
          documentCreateByUsername: t.create_by_username
        }
        batch_actions.push(
          so_approve_biz_data
            .execAction({
              params: price_form,
              fields: ["id"]
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///approve
  async approveData(items) {
    let _actions = []
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )
    _.each(items, t => {
      _actions.push(
        update_status_biz_data
          .execAction({
            params: {
              IsApproved: t.is_approved == true ? 1 : 0,
              ApproveBy: t.local_username,
              status_id: t.status_id
            },
            fields: ["is_update_ok"]
          })
          .action({
            output_last_item_map: {
              is_update_ok: "is_update_ok"
            }
          })
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  ///del
  async deleteData(items) {
    let _actions = []

    _.each(items, t => {
      _actions.push(
        biz_data
          .deleteAction({
            params: {
              id: t.id
            },
            fields: ["id", "deleted_by", "deleted_at"]
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  ///get  获取供应商报价相关
  async getPriceRelated(_params) {
    let _actions = []
    const code_biz_data = new biz_data_helper.base_entity_helper("get_vend_price_related", {}, {})
    _actions.push(
      code_biz_data
        .execAction({
          params: _params
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules }

